(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-alternative"] && !Shopify.designMode) return;
  try {
    class ProductAlternative extends HTMLElement {
    selectors = {
      skeletonContainer: '#pa-skeleton',
      productContainer: '#pa-products',
      visitPDPButton: '[data-visit-pdp]',
      sectionContainer: '#section-container',
    };
    visitPDPLabel = 'Checkout Product';
    skeletonContainer;
    productContainer;

    constructor() {
      super();
    }
    connectedCallback() {
      this._onProductVariantChange = (evt) => {
        const variant = evt.detail.variant;
        if (!variant.available) {
          this.updateProductAlternative();
        }
      };

      this.visitPDPLabel = this.dataset.visitPdpLabel;

      this.skeletonContainer = this.querySelector(this.selectors.skeletonContainer);
      this.productContainer = this.querySelector(this.selectors.productContainer);

      document.addEventListener('product:variant-change', this._onProductVariantChange);

      this.updateProductAlternative();
    }

    fetchRelatedProducts() {
      return fetch(
        window.Shopify.routes.root +
          `recommendations/products?section_id=product-alternative-section&product_id=${this.dataset.prodId}&limit=2&intent=related`
      );
    }

    updateProductAlternative() {
      this.showSkeleton();

      this.fetchRelatedProducts()
        .then((markup) => markup.text())
        .then((html) => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          const sectionContainer = tempDiv.querySelector(this.selectors.sectionContainer);

          if (sectionContainer) {
            const btns = sectionContainer.querySelectorAll(this.selectors.visitPDPButton);

            if (btns && btns.length > 0) {
              btns.forEach((btn) => {
                btn.innerHTML = this.visitPDPLabel;
              });
            }

            this.productContainer.innerHTML = sectionContainer.innerHTML;
            this.hideSkeleton();
            this.showSection();
          } else {
            this.hideSection();
          }
        })
        .catch((error) => {
          console.error('Error fetching related products:', error);
          this.hideSection();
        });
    }

    hideSkeleton() {
      if (this.skeletonContainer.dataset.show !== 'true') return;
      this.skeletonContainer.classList.add('hidden');
    }
    showSkeleton() {
      if (this.skeletonContainer.dataset.show !== 'false') return;
      this.skeletonContainer.classList.remove('hidden');
    }
  }

  customElements.define('product-alternative', ProductAlternative);
  } catch(e) { console.error(e); }
})();

})();
